import { ApiRoutes, TrackingParams } from './types';
import { getCookie } from 'utils/cookie';
import { getTimestamp } from 'utils/get-timestamp';
import { fetchApiClient } from '../fetch-api-client';

const buildTrackingData = (contentId: string): TrackingParams => {
  const sessionValue = getCookie('rm_session') || '';

  return {
    link: {
      name: 'session',
      value: sessionValue,
    },
    impressionContentId: contentId,
    timestamp: getTimestamp(),
  };
};

export const impressionViewTracking = (contentId: string): Promise<void> => {
  const data = buildTrackingData(contentId);

  return fetchApiClient.post<void>(ApiRoutes.IMPRESSION_VIEW, data);
};

export const impressionClickTracking = (contentId: string): Promise<void> => {
  const data = buildTrackingData(contentId);

  return fetchApiClient.post<void>(ApiRoutes.IMPRESSION_CLICK, data);
};
